import { type Dispatch, type SetStateAction, useState } from "react";

// Hook to simplify toggling of a boolean state value
// Returns value, method to toggle boolean value and method to set the boolean value
export const useStateToggle = (initialValue = false): [boolean, () => void, Dispatch<SetStateAction<boolean>>] => {
    const [value, setValue] = useState(initialValue);
    const toggleValue = (): void => {
        // function update form of setValue to ensure we always toggle based on the latest value
        setValue((prev) => !prev);
    };
    return [value, toggleValue, setValue];
};
